import { Box, Button, Tooltip } from '@mui/material';
import { toString } from 'lodash';
import { useState } from 'react';
import { MAX_ALLOWED_COMPONENTS } from 'src/constants';
import { ComponentTypes, IAssemblyComponent } from 'src/interfaces';
import { lang } from 'src/utils';

import { ComponentInfo } from '../componentInfo';
import { AddDefaultPanelProps } from './AddDefaultPanel.interface';
import { ButtonContainer } from './AddDefaultPanel.styled';

export const AddDefaultPanel = (props: AddDefaultPanelProps) => {
  const [showTooltip, setShowTooltip] = useState(false);
  const suggestedComponentTypes =
    props.selectedSection?.config?.suggestedComponentTypes;
  const disabledRotations =
    props.selectedSection?.config?.dynamicHighlight &&
    (suggestedComponentTypes?.includes(ComponentTypes.COD) ||
      suggestedComponentTypes?.includes(ComponentTypes.COD_THANK_YOU));

  return (
    <Box>
      {props.assemblyComponents.length > 0 ? (
        <>
          {props.assemblyComponents.map((assemblyComponent, index) => (
            <ComponentInfo
              key={assemblyComponent.uid}
              onReplacedComponent={() =>
                props.onReplacedComponent(
                  toString(assemblyComponent.uid),
                  assemblyComponent.component?.id as number,
                )
              }
              onDeletedAssemblyComponent={() =>
                props.onDeletedAssemblyComponent(assemblyComponent)
              }
              assemblyComponent={assemblyComponent}
              onUpdateRotationDuration={(uid, duration, type) =>
                props.onUpdateRotationDuration(toString(uid), duration, type)
              }
              availableRotations={props.assemblyComponents.length}
              componentIndex={index}
              onReorderRotation={props.onReorderRotation}
              onSelectBackupComponent={props.onSelectBackupComponent}
              backupAssemblyComponent={props.backupAssemblyComponent}
              onDeletedBackupAssemblyComponent={
                props.onDeletedBackupAssemblyComponent
              }
              parentBackupAssemblyComponents={
                props.parentBackupAssemblyComponents
              }
              isCodConfirmationOpen={props.isCodConfirmationOpen}
              activeAssemblyJourney={props.activeAssemblyJourney}
              customerState={props.customerState}
              assemblyId={props.assemblyId}
              showOwnerOperatorPermissions={props.showOwnerOperatorPermissions}
              replaceCurrentComponentText={props.replaceCurrentComponentText}
              showSoftSellInfo={props.showSoftSellInfo}
              removeComponentTitleText={props.removeComponentTitleText}
              handleUpdateBackupAssemblyComponents={
                props?.handleUpdateBackupAssemblyComponents
              }
              productFilters={props?.productFilters}
              productVariationFilters={props?.productVariationFilters}
              skipProductsApiOnEmptyFilters={
                props?.skipProductsApiOnEmptyFilters
              }
            />
          ))}
          {!disabledRotations ? (
            <ButtonContainer>
              <Tooltip
                title={lang.maxRotationsTooltip}
                placement="right"
                open={showTooltip}
                onMouseEnter={() => {
                  props.assemblyComponents.length >= 5 && setShowTooltip(true);
                }}
                onMouseLeave={() => {
                  setShowTooltip(false);
                }}
                arrow>
                <span>
                  <Button
                    disabled={
                      props.assemblyComponents.length >= MAX_ALLOWED_COMPONENTS
                    }
                    onClick={props.onChangedAddComponent}>
                    {lang.addAdditionalComponent}
                  </Button>
                </span>
              </Tooltip>
            </ButtonContainer>
          ) : null}
        </>
      ) : props.parentAssemblyComponent.length > 0 &&
        props.editable &&
        props.childSectionEdit === false ? (
        <>
          {props.parentAssemblyComponent?.map(
            (parentAssemblyComponent, index) => (
              <ComponentInfo
                key={parentAssemblyComponent.uid}
                onReplacedComponent={() =>
                  props.onReplacedComponent(
                    toString(parentAssemblyComponent.uid),
                    parentAssemblyComponent.component?.id as number,
                  )
                }
                onDeletedAssemblyComponent={() =>
                  props.onDeletedAssemblyComponent(
                    parentAssemblyComponent as IAssemblyComponent,
                  )
                }
                assemblyComponent={
                  parentAssemblyComponent as IAssemblyComponent
                }
                onUpdateRotationDuration={(uid, duration, type) =>
                  props.onUpdateRotationDuration(toString(uid), duration, type)
                }
                availableRotations={props.parentAssemblyComponent.length}
                componentIndex={index}
                onReorderRotation={props.onReorderRotation}
                editable={props.editable}
                onSelectBackupComponent={props.onSelectBackupComponent}
                backupAssemblyComponent={props.backupAssemblyComponent}
                onDeletedBackupAssemblyComponent={
                  props.onDeletedBackupAssemblyComponent
                }
                parentBackupAssemblyComponents={
                  props.parentBackupAssemblyComponents
                }
                isCodConfirmationOpen={props.isCodConfirmationOpen}
                activeAssemblyJourney={props.activeAssemblyJourney}
                customerState={props.customerState}
                assemblyId={props.assemblyId}
                showOwnerOperatorPermissions={
                  props.showOwnerOperatorPermissions
                }
                replaceCurrentComponentText={props.replaceCurrentComponentText}
                showSoftSellInfo={props.showSoftSellInfo}
                removeComponentTitleText={props.removeComponentTitleText}
                handleUpdateBackupAssemblyComponents={
                  props?.handleUpdateBackupAssemblyComponents
                }
                productFilters={props?.productFilters}
                productVariationFilters={props?.productVariationFilters}
                skipProductsApiOnEmptyFilters={
                  props?.skipProductsApiOnEmptyFilters
                }
              />
            ),
          )}
        </>
      ) : (
        <ButtonContainer>{props.initialPanelContent}</ButtonContainer>
      )}
    </Box>
  );
};
